module.exports = __webpack_public_path__ + "img/spa-nails.ebb7c62c.svg";